/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{s as e}from"./vec4.js";import{c as o}from"./vec4f64.js";import{Float2PassUniform as i}from"../views/3d/webgl-engine/core/shaderModules/Float2PassUniform.js";import{Float4PassUniform as t}from"../views/3d/webgl-engine/core/shaderModules/Float4PassUniform.js";import{glsl as l}from"../views/3d/webgl-engine/core/shaderModules/interfaces.js";import{ShaderBuilder as r}from"../views/3d/webgl-engine/core/shaderModules/ShaderBuilder.js";import{Texture2DPassUniform as n}from"../views/3d/webgl-engine/core/shaderModules/Texture2DPassUniform.js";import{VertexAttribute as a}from"../views/3d/webgl-engine/lib/VertexAttribute.js";import{o as s,b as u}from"./HighlightDownsample.glsl.js";function c(){const o=new r,{vertex:c,fragment:g}=o,f=c.code,h=g.code;return o.attributes.add(a.POSITION,"vec2"),o.varyings.add("uv","vec2"),o.attributes.add(a.UV0,"vec2"),c.uniforms.add(new n("coverageTex",(e=>e.coverageTexture)),new i("coverageRounding",(e=>e.coverageRounding))),f.add(l`void main() {
vec4 cov = texture(coverageTex, uv0 * coverageRounding);
if (cov.r == 0.0) {
gl_Position = vec4(0.0);
return;
}
gl_Position = vec4(position, 0.0, 1.0);
uv = position.xy * 0.5 + vec2(0.5);
}`),g.uniforms.add(new n("tex",(e=>e.blurTexture)),new n("highlightTexture",(e=>e.highlightTexture)),new t("uColor",(e=>e.color)),new t("haloColor",(e=>e.haloColor)),new t("opacities",(o=>e(d,o.haloOpacity,o.haloOpacityOccluded,o.fillOpacity,o.fillOpacityOccluded)))),g.constants.add("outlineSize","float",s),g.constants.add("blurSize","float",u),h.add(l`void main() {
vec4 blurredHighlightValue = texture(tex, uv);
float highlightIntensity = blurredHighlightValue.a;
if (highlightIntensity == 0.0) {
discard;
}
vec4 origin_color = texture(highlightTexture, uv);
float outlineIntensity;
float fillIntensity;
if (blurredHighlightValue.g > blurredHighlightValue.b) {
outlineIntensity = haloColor.w * opacities[1];
fillIntensity = uColor.w * opacities[3];
}
else {
outlineIntensity = haloColor.w * opacities[0];
fillIntensity = uColor.w * opacities[2];
}
float inner = 1.0 - (outlineSize - blurSize) / outlineSize;
float outlineFactor = smoothstep(0.0, inner, highlightIntensity);
float fillFactor = any(notEqual(origin_color, vec4(0.0, 0.0, 0.0, 0.0))) ? 1.0 : 0.0;
float intensity = outlineIntensity * outlineFactor * (1.0 - fillFactor) + fillIntensity * fillFactor;
fragColor = vec4(mix(haloColor.rgb, uColor.rgb, fillFactor), intensity);
}`),o}const d=o(),g=Object.freeze(Object.defineProperty({__proto__:null,build:c},Symbol.toStringTag,{value:"Module"}));export{g as H,c as b};
